import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CircularProgress from "@mui/material/CircularProgress";

import BoatHelm from "../../../../Asset/icon/boat_helm.svg";
import InfoCard from "../../../../components/card/InfoCard";
import {
  getDestinationDetail,
  getProvinceDetail,
  getCountryDetail,
} from "../../../../redux/centerData/CenterDataSlice";
import "../../../../Asset/scss/takemyyacht.scss";

function BodyTopDestinations() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  const destinations = useSelector(
    (state) => state.CenterDataSlice.Destination.results || []
  );
  const provinces = useSelector(
    (state) => state.CenterDataSlice.Province.results || []
  );
  const countries = useSelector(
    (state) => state.CenterDataSlice.Country.results || []
  );

  const country = countries.find((e) => e.country_name === "Thailand");

  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 719);

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getDestinationDetail());
        await dispatch(getProvinceDetail());
        await dispatch(getCountryDetail());
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();

    const handleResize = () => setIsMobile(window.innerWidth < 719);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch]);

  const renderSlides = () =>
    destinations.map((destination, index) => {
      const matchingProvince = provinces.find(
        (province) => province.ProvinceID === destination.id_province
      );
      return (
        <SwiperSlide
          key={`${destination.id_province}-${destination.name_destination_en || index
            }`}
        >
          <Link
            to={`/destination/detailIsland/${destination.name_destination_en}`}
          >
            <InfoCard
              image={destination.destination_img}
              headline={
                selectedLanguage === "en"
                  ? destination.name_destination_en
                  : destination.name_destination_th
              }
              location={
                selectedLanguage === "en"
                  ? matchingProvince?.ProvinceEng
                  : matchingProvince?.ProvinceThai
              }
              country={
                selectedLanguage === "en" ? country?.country_name : "ประเทศไทย"
              }
            />
          </Link>
        </SwiperSlide>
      );
    });

  return (
    <div className="destination-section-container">
      <h2 className="exploring-title">{t("exploring")}</h2>
      <img
        className="boat-helm-icon"
        draggable={false}
        src={BoatHelm}
        alt="BoatHelm"
      />
      <div className="Header mb-5 ml-1">
        <h2>{t("topDestination")}</h2>
      </div>

      <div
        className="destination-carousel-wrapper relative"
      >
        <Swiper
          modules={[Autoplay, Navigation]}
          slidesPerView={isMobile ? 2 : 6}
          spaceBetween={20}
          centeredSlides={destinations.length === 1}
          loop={true}
          autoplay={{ delay: 4000 }}
          navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
          onSwiper={(swiper) => {
            setTimeout(() => {
              if (swiper.params.navigation) {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
                swiper.navigation.destroy();
                swiper.navigation.init();
                swiper.navigation.update();
              }
            });
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            720: { slidesPerView: 2 },
            1024: { slidesPerView: 6 },
          }}
        >
          {" "}
          {renderSlides()}{" "}
        </Swiper>

        {/* ปุ่ม Previous */}
        <img
          ref={prevRef}
          className="PreviousBtn absolute-left-center"
          draggable="false"
          src="/static/media/previous.1eb2e3d917050e427af4a865ebf11932.svg"
          alt="Previous"
        />

        {/* ปุ่ม Next */}
        <img
          ref={nextRef}
          className="NextBtn absolute-right-center"
          draggable="false"
          src="/static/media/next.c30fc62b5e4797c454d80d20a129c6c6.svg"
          alt="Next"
        />
      </div>
    </div>
  );
}

export default BodyTopDestinations;
